import { storageInboundStepDefinitions } from "../StorageInboundStepRoutes";

export const isStorageInboundStepPath = (pathKey: string) =>
  !!storageInboundStepDefinitions.find((stepDefinition) => stepDefinition.pathKey === pathKey);
